// extracted by mini-css-extract-plugin
export var actionButton = "_lt-t";
export var buttonContainer = "_lt-0";
export var buttonContainer2 = "_lt-1";
export var buttonSection = "_lt-2";
export var details = "_lt-3";
export var dropdownItem = "_lt-5";
export var dropdownItemsContainer = "_lt-4";
export var fileInput = "_lt-r";
export var headerButton = "_lt-6";
export var icon = "_lt-7";
export var input = "_lt-8";
export var macroListItem = "_lt-9";
export var mainContent = "_lt-a";
export var microText = "_lt-b";
export var modal = "_lt-w";
export var optionsButton = "_lt-c";
export var paperclip = "_lt-s";
export var pillContent = "_lt-d";
export var preview = "_lt-e";
export var preview2 = "_lt-f";
export var quillEditor = "_lt-q";
export var selectedMacro = "_lt-g";
export var sidebar = "_lt-h";
export var sidebarHeader = "_lt-j";
export var sidebarList = "_lt-i";
export var sidebarListItem = "_lt-k";
export var sidebarSearch = "_lt-l";
export var snoozeDurationWrapper = "_lt-v";
export var statusPillContainer = "_lt-m";
export var tagsContainer = "_lt-n";
export var unselectedMacro = "_lt-o";
export var variable = "_lt-u";
export var wrapper = "_lt-p";